import {
  PortalFactsType,
} from '@refx/shared-common';
import {
  of,
} from 'rxjs';

export const portalFacts = () => (facts?: PortalFactsType[]) => {
  const mappedFacts = facts?.reduce((acc: PortalFactsType, current: {key: string;
    value: string;}) => {
    acc[current.key] = current.value;
    return acc;
  }, {});
  return of(mappedFacts);
};
